export enum AssociationContentTypeEnum {
  /** Orgs *and* groups added to a bundle. */
  Both = 'both',
  /** Orgs or groups added to a bundle. */
  Bundle = 'bundle',
  /** Groups added to a bundle. */
  Group = 'group',
  /** Orgs added to a group. */
  GroupOrgs = 'groupOrgs',
}

export type AssociationContentType =
  | AssociationContentTypeEnum.Group
  | AssociationContentTypeEnum.Bundle;

export interface AssociationListType {
  list: any;
  propertyNameToGrab: string;
  selectedProperty: string;
}

export interface AssociationListTypes {
  group: AssociationListType;
  bundle: AssociationListType;
}

export interface AssociationList {
  group: GroupServerItem[];
  bundle: OrgServerItem[];
}

export interface AssociationModalResolve {
  container: {
    organizationId: number;
    containerId?: number;
  };
  includeTabs: boolean;
  titleText: string;
  type: AssociationContentType;
  handleAddGroupsToBundle: (selected: BundleGroupItem[]) => void;
  handleAddToBoth: (
    selectedOrgs: BundleOrgItem[],
    selectedGroups: BundleGroupItem[]
  ) => void;
  handleAddToBundles: (selected: BundleGroupItem[] | BundleOrgItem[]) => void;
  handleAddToGroups: (selected: BundleOrgItem[]) => void;
  getOrgs: () => Promise<{ data: BundleOrgItem[] }>;
}

export interface GroupServerItem {
  groupId: number;
  name: string;
  enabled: boolean;
}

export interface OrgServerItem {
  cacheEncryptedData: boolean;
  dateCreated: string;
  description?: string;
  description_Secure?: string;
  encrypt: boolean;
  name: string;
  name_Secure?: string;
  organizationId: number;
  tenantOrganizationId: number;
  url: string;
  url_Secure?: string;
}

export interface BundleGroupItem extends GroupServerItem {
  isSelected?: boolean;
}

export interface BundleOrgItem extends OrgServerItem {
  isSelected?: boolean;
}

export type BundleItem = BundleGroupItem | BundleOrgItem;
